export const SupportConstants = {
    Mail: "supporthetaarbeten@brandskyddsforeningen.se",
    MailUrl: "mailto:supporthetaarbeten@brandskyddsforeningen.se",
    Phone: "08-588 475 40",
    PhoneUrl: "tel:+46858847540",
};
